<template>
    <v-col
        class="pl-0 py-0"
    >
        <v-row>
            <v-card
                class="mx-3 mt-3 pa-1 d-flex"
                flat
            >
                
                 <v-card
                    width="680"
                    flat
                    outlined
                >
                    <v-data-table
                        :headers="headers"
                        :items="table2Records"
                        dense                    
                        fixed-header
                        height="505"
                        disable-pagination
                        hide-default-footer                        
                    >
                        <template v-slot:item="{ item }">
                             <SubjectRow
                                v-bind:item="item"
                                v-bind:formLevel="formLevel"
                                v-bind:term="currentTerm"
                                v-bind:maxCourse="maxCourse"
                                v-bind:maxExam="maxExam"
                                v-on:update-average="getAverage"
                            ></SubjectRow>                       
                        </template>
                        
                    </v-data-table>
                </v-card >

                <!-- Subjects -->
                <v-card
                    width="76"
                    flat
                    outlined
                >
                    <v-data-table
                        :headers="headersSubjects"
                        :items="studentSubjects"
                        dense
                        fixed-header
                        height="350"
                        disable-pagination
                        hide-default-footer
                    >
                        <template v-slot:item="{ item }">
                            <tr>
                                <td style="max-width: 1px; white-space: nowrap; overflow:hidden; text-overflow: ellipsis; ">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span
                                                v-bind="attrs"
                                                v-on="on"
                                                :class="classStudentSubjects(item)"
                                            > 
                                                {{ item.abbr}} 
                                            </span>
                                        </template>
                                        <span>{{ item.title}}</span>
                                    </v-tooltip>                                   
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
                   
            </v-card>
        </v-row>

        <div class="px-1 mt-3">
            <v-card flat class="d-flex justify-space-between">
                    <v-menu
                        v-model="formTeacherCommentMenu"
                        bottom
                        origin="center center"
                        transition="scale-transition"
                        :close-on-content-click="false"
                        
                    >   
                        <template v-slot:activator="{ on, attrs }">
                            <v-textarea                                       
                                label="Form Teacher's Remarks"  
                                v-model="studentRecord.comments"  
                                placeholder=" "                        
                                persistent-hint
                                dense
                                rows="4"
                                class="text-caption mr-4"
                                no-resize
                                maxlength="500"
                                :readonly="disableFormTeacherComment"
                                :filled="disableFormTeacherComment"
                                @blur="updateRecord"
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                hide-details="auto"
                            >                        
                            </v-textarea>
                        </template>
                        <v-card>
                            <v-card-title> Form Teacher's Remarks</v-card-title>
                                <v-card-text>
                                    <v-textarea                                       
                                        v-model="studentRecord.comments"  
                                        dense
                                        class="text-caption"
                                        maxlength="500"
                                        :readonly="disableFormTeacherComment"
                                        :filled="disableFormTeacherComment"
                                        @blur="updateRecord"
                                        outlined
                                        style="width:40vw"
                                        counter
                                    >                        
                                    </v-textarea>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="formTeacherCommentMenu = false">Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>

                    <v-menu
                        v-model="deanCommentMenu"
                        bottom
                        origin="center center"
                        transition="scale-transition"
                        :close-on-content-click="false"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-textarea                                       
                                label="Dean's Remarks"  
                                v-model="studentRecord.dcomments"  
                                placeholder=" "                        
                                persistent-hint
                                dense
                                rows="4"
                                class="text-caption"
                                no-resize
                                maxlength="255"
                                :readonly="disabledDeanComment"
                                :filled="disabledDeanComment"
                                @blur="updateRecord"
                                outlined
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on"
                            >                        
                            </v-textarea>
                        </template> 
                        
                        <v-card>
                            <v-card-title> Dean's Remarks</v-card-title>
                            <v-card-text>
                                <v-textarea                                       
                                    v-model="studentRecord.dcomments"  
                                    persistent-hint
                                    dense
                                    class="text-caption"
                                    no-resize
                                    maxlength="500"
                                    counter
                                    :readonly="disabledDeanComment"
                                    :filled="disabledDeanComment"
                                    @blur="updateRecord"
                                    outlined
                                    hide-details="auto"
                                    style="width:40vw"
                                >                        
                                </v-textarea>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="deanCommentMenu = false">Close</v-btn>
                            </v-card-actions>
                        </v-card>

                    </v-menu>   
                    

                   <div class="d-flex flex-column ml-3">
                       <div class="d-flex justify-space-between mb-4">
                               <v-btn 
                               class="text-caption pa-2  white--text"
                               width="64"
                               height="30"                
                               color="primary"
                               @click="previousRecord"
                               :disabled="!pagination.prev_page"                
                           >
                               <div class="d-flex justify-center align-center pr-2"> 
                                   <v-icon class="">mdi-chevron-left</v-icon>
                                   <span>PREV</span>
                               </div>                                         
                           </v-btn>
           
                           <v-btn 
                               class="text-caption pa-2 mx-2"
                               width="64"
                               height="30"
                               outlined
                               disabled                
                               text  
                           >
                               <span class="blue--text">{{pagination.current_page}} of {{ pagination.last_page}}</span>                                                        
                           </v-btn>
           
                           <v-btn 
                               class="text-caption pa-2  white--text"
                               width="64"
                               height="30"
                               dark
                               color="primary"
                               @click="nextRecord"
                               :disabled="!pagination.next_page"
                           >
                               <div class="d-flex justify-center align-center pl-2">
                                   <span>NEXT</span>
                                   <v-icon>mdi-chevron-right</v-icon>
                               </div>                                         
                           </v-btn>
                       </div>

                       <div class="d-flex justify-space-between">
                           <v-btn
                               outlined
                               small
                               color="primary"
                               @click="searchStudent"
                               width="64"
                           >
                               <span style="font-size: 0.6rem">Search</span>
                           </v-btn>
   
                           <v-btn                        
                               outlined
                               small
                               color="primary"
                               @click="nextClass"
                               width="64"
                           >
                               <div class="d-flex flex-column">
                                <span style="font-size: 0.6rem">Next</span>
                                <span style="font-size: 0.6rem">Class</span>
                               </div>
                           </v-btn>
   
   
                           <v-btn                        
                               small
                               dark
                               color="red"
                               width="64"
                               @click="closeEditViewTermReports"
                           >
                               <div class="d-flex flex-column">
                                <span style="font-size: 0.6rem">Close</span>
                                <span style="font-size: 0.6rem">Form</span>
                               </div>
                           </v-btn>
   
                       </div>
                   </div>

                        
                   
            </v-card>    
        </div>
        
        <!-- Search for Student Record -->
        <v-overlay
            absolute
            :value="overlaySearch"
            color="secondary"
            opacity="0.6"
        >
            <v-expand-transition>
                <v-card
                    max-width="600"
                    class="mx-auto pa-6"
                    transition="scroll-y-transition"
                    v-show="expand"
                    light
                >
                    <v-card-title
                        class="mb-6"
                    >
                        <v-text-field
                            v-model="search"
                            label="Search for Student Record"
                            append-icon="mdi-magnify"
                            class="mx-4"
                            hide-details
                            single-line
                            clearable
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="headersStudents"
                        :items="table1Records"
                        :search="search"
                        fixed-header
                        height="40vh"
                        :options="options"
                        dense
                    >
                        <template
                            v-slot:[`item.actions`]="{ item }"
                        >
                            <v-btn
                                text
                                color="primary"
                                @click="viewRecord(item)"
                            >
                                View Record
                            </v-btn>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            outlined
                            @click="cancelSearch"
                        >
                            Cancel Search
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-expand-transition>
        </v-overlay>        
    </v-col>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import SubjectRow from './EditViewTermReportsSubjectRow';

export default {
    components: {        

        SubjectRow,
    },
        
    data: () => ({
        headers: [],
        headersSubjects:[],
        headersStudents: [
            { text: 'Student ID', align: 'center', value: 'student_id', width: '75' },
            { text: 'First Name', align: 'left', value: 'first_name', width: '100' },
            { text: 'Last Name', align: 'left', value: 'last_name', width: '100' },
            { text: '', align: 'center', value: 'actions', sortable: false, width: '150' },
        ],
        subjectRecords: [],        
        studentAverage: '',
        studentPasses: null,
        studentDistinctions: '-',
        imageSrc: null,        
        value: ' ', 
        rules: [],
        isValid: true, 
        record: {},
        subjectRecord: [],
        disabled: true,
        displayAverage: false,
        displayGrade: false,
        displayPasses: false,
        displayDistinctions: false,
        formLevel: null,
        btnClass: 'text-caption pa-2  white--text',
        codedComment: null,
        styleFontSize: '0.7rem',
        overlaySearch: false, 
        expand: false, 
        search: null,  
        options: {
            itemsPerPage: -1,
        },
        dialog: false,
        maxCourse: 100,
        maxExam: 100, 
        disableFormTeacherComment: false,
        formTeacherCommentMenu: false,
        deanCommentMenu: false, 
        disabledDeanComment: false,                
    }),

    watch: {       
        table2Records: {
            deep: true,
            handler () {                                           
                this.setTableHeaders();
            }
        },

        studentRecord: {
            handler(val){ 
                this.initialize();               
                this.formLevel = val.form_level;
                if(
                    this.formTeacherClass.indexOf(this.studentRecord.class_id) === -1 && 
                    !this.admin &&
                    this.deanFormClasses.indexOf(this.studentRecord.class_id) === -1
                ){
                    //console.log('Not the form Teacher');
                    this.disabled = true;
                }
                else{
                    //console.log('Assigned Form Teacher');
                    this.disabled = false;
                }
                //this.setTableHeaders();
                //console.log(this.selectedFormClass);
            }
        },
        
    },

    computed: {
        ...mapGetters({
            sheet: 'termReports/getCommentSheet',
            formTeacherComments: 'termReports/getFormTeacherComments',
            table2Records: 'termReports/getEditViewTermReportsTable2Records',            
            studentRecord: 'termReports/getSelectedStudentRecord',
            formTeacherClass: 'termReports/getFormTeacherClass',
            formClasses: 'termReports/getFormClasses',
            currentTerm: 'termReports/getCurrentTerm',
            pagination: 'termReports/getPagination',
            selectedFormClass: 'termReports/getSelectedFormClass',
            table1Records: 'termReports/getTable1Records',
            studentSubjects: 'termReports/getEditViewTermReportsStudentSubjects',
            admin: 'auth/getAdmin',
            subjectWeightings: 'termReports/getSubjectWeightings',
            deanFormClasses: 'termReports/getDeanFormClasses', 
            editTermReports: 'admin/getEditTermReports', 
            selectedFormLevel: 'termReports/getSelectedFormLevel',
        }),       

        getStudentAverage () {
            return isNaN(this.studentAverage) ? this.studentAverage : this.studentAverage + ' %';
        },
        
        
    },
    methods: {
        ...mapMutations({
            setCommentSheet: 'termReports/setCommentSheet',
            setSaveStatus: 'termReports/setEditViewTermReportsSaveStatus',
            setSaving: 'termReports/setEditViewTermReportsSaving',
            setSaveError: 'termReports/setEditViewTermReportsSaveError',
            setSaved: 'termReports/setEditViewTermReportsSaved',
            setPagination: 'termReports/setPagination',
            setSelectedStudentRecord: 'termReports/setSelectedStudentRecord',
            setTable2Records: 'termReports/setEditViewTermReportsTable2Records',
            setEditViewTermReports: 'termReports/setEditViewTermReports',
            setOverlay: 'termReports/setEditViewTermReportsOverlay',
            setExpand: 'termReports/setEditViewTermReportsExpand', 
            setLoading: 'termReports/setEditViewTermReportsLoading', 
            setStudentSubjects: 'termReports/setEditViewTermReportsStudentSubjects', 
            setSelectedStudentRank: 'termReports/setSelectedStudentRank',
        }),

        ...mapActions({
            postTable1Record: 'termReports/postTable1Record',
            
            setErrorResponse: 'termReports/setErrorResponse',
            getTable2Records: 'termReports/getTable2Records',
        }),

        async initialize () {
            //
        },

        getAverage(){
            this.styleFontSize = null;                   
            let recordCount = 0; 
            let totalMarks = 0;
            const { form_level } = this.studentRecord;
            
            this.table2Records.forEach(record => {
                recordCount++; 

                if( record.term == 1  && form_level > 4) {
                    totalMarks += record.course_mark ;
                }
                else if( record.term == 2  && form_level <= 4) {
                    totalMarks += record.course_mark;
                }
                else if( record.term == 2  && form_level > 4) {
                    totalMarks += record.exam_mark;
                }
                else{
                    totalMarks += record.course_mark*0.3 + record.exam_mark*1;
                }
                
            })
            
            console.log('total marks: ', totalMarks);

            if(recordCount != 0 ){               
                this.studentAverage =  (parseFloat(totalMarks.toFixed(2)) / recordCount).toPrecision(3);
            }
            else if(recordCount == 0) this.studentAverage = '--';
           
            
        },

        async updateRecord(){
            console.log('updating...');
            this.setSaveStatus('Saving...');
            this.setSaving(true);
            this.setSaved(false);
            this.setSaveError(false);
            //this.studentRecord.lib_comment = this.codedComment.id;           
            //console.log(this.studentRecord);
            try{
                await this.postTable1Record();
                this.setSaveStatus('Record Saved');
                this.setSaving(false);
                this.setSaved(true);
                this.setSaveError(false);
                //console.log(response);
            } catch (error) {
                console.log(error);
                this.setSaveStatus('Error Occured');
                this.setSaving(false);
                this.setSaved(false);
                this.setSaveError(true);
                this.setErrorResponse(error);
            }            
        },

        setTableHeaders () {
            this.headersSubjects = [{text: 'Subjects', value: 'abbr', sortable:false}]
            // console.log('current term: ', this.currentTerm);
            // console.log('form level: ', this.selectedFormLevel);

            if(
                (this.currentTerm == 1 && this.selectedFormLevel > 4) ||
                (this.currentTerm == 2 && this.selectedFormLevel <= 4)
            ){
                this.maxCourse = 100;
                this.maxExam = 0;
                this.headers = [
                    {text: 'Code', align: 'center', value: 'subject_id', width: '60', sortable: false},
                    {text: 'Subject', align: 'start', value: 'abbr', width: '80', sortable: false},
                    {text: 'Course (100)', align: 'start', value: 'course_mark', width: '60', sortable: false},
                    {text: 'Exam     (---)', align: 'start', value: 'exam_mark', width: '60', sortable: false},
                    {text: 'Late', align: 'start', value: 'late', width: '50', sortable: false},
                    {text: 'Abs', align: 'start', value: 'absent', width: '50', sortable: false},
                    {text: 'App', align: 'start', value: 'app', width: '50', sortable: false},
                    {text: 'Con', align: 'start', value: 'con', width: '50', sortable: false},               
                    {text: "Subject Teacher's Remarks", align: 'start', value: 'con', width: '150', sortable: false},               
                    {text: '', align: 'start', value: 'actions', sortable: false}               
                ];
                return;     
            }

            // console.log(`form level: ${this.selectedFormLevel} `, this.selectedFormLevel > 4);


            if(this.selectedFormLevel > 4){
                console.log('form level > 4');
                this.maxCourse = 0;
                this.maxExam = 100;
                this.headers = [
                    {text: 'Code', align: 'center', value: 'subject_id', width: '60', sortable: false},
                    {text: 'Subject', align: 'start', value: 'abbr', width: '80', sortable: false},
                    {text: 'Course  (---)', align: 'start', value: 'course_mark', width: '60', sortable: false},
                    {text: 'Exam (100)', align: 'start', value: 'exam_mark', width: '60', sortable: false},
                    {text: 'Late', align: 'start', value: 'late', width: '50', sortable: false},
                    {text: 'Abs', align: 'start', value: 'absent', width: '50', sortable: false},
                    {text: 'App', align: 'start', value: 'app', width: '50', sortable: false},
                    {text: 'Con', align: 'start', value: 'con', width: '50', sortable: false},               
                    {text: "Subject Teacher's Remarks", align: 'start', value: 'con', width: '150', sortable: false},               
                    {text: '', align: 'start', value: 'actions', sortable: false}               
                ];
                return;     
            }

            // console.log('this is true');

            this.maxCourse = 30;
            this.maxExam = 70;
            this.headers = [
                {text: 'Code', align: 'center', value: 'subject_id', width: '60', sortable: false},
                {text: 'Subject', align: 'start', value: 'abbr', width: '80', sortable: false},
                {text: 'Course (30)', align: 'start', value: 'course_mark', width: '60', sortable: false},
                {text: 'Exam (70)', align: 'start', value: 'exam_mark', width: '60', sortable: false},
                {text: 'Late', align: 'start', value: 'late', width: '50', sortable: false},
                {text: 'Abs', align: 'start', value: 'absent', width: '50', sortable: false},
                {text: 'App', align: 'start', value: 'app', width: '50', sortable: false},
                {text: 'Con', align: 'start', value: 'con', width: '50', sortable: false},               
                {text: "Subject Teacher's Remarks", align: 'start', value: 'con', width: '150', sortable: false},               
                {text: '', align: 'start', value: 'actions', sortable: false}               
            ];                    

            
             
        },
        
        classStudentSubjects (item) {
            // console.log(item);            
            if(item.entered == 1) return "font-weight-bold primary--text";
            return "font-weight-bold red--text";
        },

        nextClass () {
            this.setOverlay(true);
            this.setExpand(true);
        },

        searchStudent(){
            this.overlaySearch = true;
            setTimeout(() => {
                this.expand = true;
            })
        },

        cancelSearch(){
            this.expand = false;
            setTimeout(() => {
                this.overlaySearch = false;
            }, 600);
        },

        viewRecord(item){
            //console.log(item);
            this.expand = false;
            setTimeout(() => {
                this.overlaySearch = false;
            }, 600);
            let recordIndex = this.table1Records.indexOf(item);
            this.recordNavigation(++recordIndex);
        },

        async recordNavigation(pagination){
            this.setOverlay(true);
            this.setLoading(true);
            
            this.makePagination(pagination);
            this.setSelectedStudentRecord(this.table1Records[--pagination]);
            try {
                const { data: { table2_records, student_subjects, rank } } = await this.getTable2Records();
                this.setSelectedStudentRank(rank);
                this.setTable2Records(table2_records);
                this.setStudentSubjects(student_subjects);
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }            
            this.setOverlay(false);
            this.setLoading(false);           
        },

        makePagination(data){
            let prev_page = data;
            let current_page = data;
            let next_page = (current_page === this.pagination.last_page) ? null : ++data;
            prev_page = (current_page === 1) ? null : --prev_page;
            
            let pagination = {
                current_page: current_page,
                last_page: this.pagination.last_page,
                next_page: next_page,
                prev_page: prev_page,
            };
            this.setPagination(pagination);
        },

        closeEditViewTermReports () {
            this.setOverlay(true);
            this.setExpand(true);
        },

        async previousRecord(){
            this.setSaveStatus('');
            this.setSaving(false);
            this.setSaved(false);
            this.setSaveError(false);
            this.recordNavigation(this.pagination.prev_page);
        },

        nextRecord(){
            this.setSaveStatus('');
            this.setSaving(false);
            this.setSaved(false);
            this.setSaveError(false);
            this.recordNavigation(this.pagination.next_page);
        },

       

    }
}
</script>

<style scoped>    

    ::v-deep .v-input__slot{
        min-height: 0px !important;
        display: flex !important;
        align-items: center !important;
    }

    .v-btn__content{
        font-size: 0.8em;
    }

    ::v-deep .v-input__append-inner{
        margin-top: 0;
    }

    ::v-deep .v-select__selections{
        height: 30px;
        /*padding: 0 !important;*/
        padding-top: 2px !important;
        padding-bottom: 2px !important;
    }

    ::v-deep .v-text-field__slot input{
        text-align: center;
    }

    ::v-deep .v-text-field__slot textarea{
        line-height: 1rem;
        font-size:0.8rem;
    }

    ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 6px;
        font-size: 0.7rem;
        text-align: center;
    }

    ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
        padding: 0 6px;
        font-size: 0.75rem;
    }

    ::v-deep .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td {
        height: 22px;
    }

    ::v-deep .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > th {
        height: 22px;
    }

    ::v-deep textarea {
        padding-top: 8px;
    }

    ::v-deep .v-input input{
        height: 25px;
    }

    /* ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details{
        padding: 0 5px;
    } */

    ::v-deep .change-class .v-input__icon{
        min-width: 10px;
        width: 10px;
    }

    ::v-deep .v-list-item__title{
        min-width: 100px;
    }

    ::v-deep .v-select.v-input--dense .v-select__selection--comma{
        width: 50px;
        text-align: center;
    }

    ::v-deep .v-textarea.v-text-field--enclosed textarea{
        margin-top: 5px;
    }

    ::v-deep #label-form-class{
        position: absolute;
        top: -15px;
        right: 0;
    }

    ::v-deep .v-text-field--filled .v-label--active {
        transform: translateY(-20px) scale(0.75);
    }

    /* Chrome, Safari, Edge, Opera */
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    text-align:center
    }

    /* Firefox */
    ::v-deep input[type=number] {
    -moz-appearance: textfield;
    appearance: textfield;
    text-align: center;
    }

    ::v-deep th span{
        white-space: pre-wrap;
    }
</style>